import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

const FooterNav = ({
  className,
  ...props
}) => {

  const classes = classNames(
    'footer-nav',
    className
  );

  return (
    <nav
      {...props}
      className={classes}
    >
      <ul className="list-reset">
        <li>
          <a href={"mailto: hello@bookmarksforteams.com"}>Contact</a>
        </li>
        <li>
          <Link to="/privacypolicy">Privacy</Link>
        </li>
        <li>
          <Link to="/termsofuse">Terms of Use</Link>
        </li>
      </ul>
    </nav>
  );
}

export default FooterNav;